import { useState, useCallback } from 'react';
import FolderBrowser from './FolderBrowser';

export function useFolderPicker({ ws, onFolderSelected, onFolderBrowserClose, restrictToUserFolder = false, allowedRoots = [], displayRoot = '', allowFileSelection = false }) {
  const [showFolderBrowser, setShowFolderBrowser] = useState(false);
  // const isWindows = typeof navigator !== 'undefined' && /windows/i.test(navigator.userAgent);
  const isWindows = false; // always use FolderBrowser for simplicity

  const handleBrowseDirectory = useCallback(() => {
    if (isWindows) {
      if (ws?.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ command: 'browsedirectory' }));
      }
    } else {
      setShowFolderBrowser(true);
    }
  }, [isWindows, ws]);

  const FolderBrowserComponent = !isWindows ? (
    <FolderBrowser
      open={showFolderBrowser}
      onClose={() => {
        setShowFolderBrowser(false);
        onFolderBrowserClose?.();
      }}
      onSelect={onFolderSelected}
      restrictToUserFolder={restrictToUserFolder}
      allowedRoots={allowedRoots}
      displayRoot={displayRoot}
      allowFileSelection={allowFileSelection}
    />
  ) : null;

  return { handleBrowseDirectory, FolderBrowserComponent };
} 
